import React from 'react';
import PropTypes from 'prop-types';

/**
 * PaymentStatusBanner - Displays error or success banners for WSS payment flow
 * Matches the exact legacy HTML structure with p element and correct classes
 */
function PaymentStatusBanner({ message, type }) {
  if (!message || !message.value) {
    return null;
  }

  // Generate unique ID for the banner
  const bannerId = `problem-order__error-message-${type}`;

  // Determine CSS classes and data-variant based on type
  const bannerClass = type === 'success'
    ? 'error-message js-error-message payment-updated__content'
    : 'error-message js-error-message problem-order__content';

  return (
    <div className="payment-status-banner">
      <div className="account-block-error">
        <div className="anf payment__auth account-header__problem-order accountV2 account-container__problem-order globalV2">
          <p
            role="alert"
            id={bannerId}
            className={bannerClass}
            tabIndex="-1"
            data-variant={type}
          >
            {message.value}
          </p>
        </div>
      </div>
    </div>
  );
}

PaymentStatusBanner.propTypes = {
  message: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  type: PropTypes.oneOf(['error', 'success']),
};

PaymentStatusBanner.defaultProps = {
  message: null,
  type: 'error',
};

export default PaymentStatusBanner;
